import { render, staticRenderFns } from "./ChatGPTDataset.vue?vue&type=template&id=840682be&scoped=true&"
import script from "./ChatGPTDataset.vue?vue&type=script&lang=js&"
export * from "./ChatGPTDataset.vue?vue&type=script&lang=js&"
import style0 from "./ChatGPTDataset.vue?vue&type=style&index=0&id=840682be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840682be",
  null
  
)

export default component.exports